import './list_tags_component.scss'
import { Controller } from 'stimulus'

export default class extends Controller {
  static classes = ['open']
  static targets = ['tags', 'toggle']

  connect = (): void => {
    if (this.ellipsis) this.toggleTarget.remove()
  }

  toggle = (): void => {
    this.opened() ? this.close() : this.open()
  }

  open = (): void => {
    this.tagsTarget.classList.add(this.openClass)
    this.toggleTarget.innerHTML = 'Show fewer'
  }

  close = (): void => {
    this.tagsTarget.classList.remove(this.openClass)
    this.toggleTarget.innerHTML = 'Show more'
  }

  opened = (): boolean => {
    return this.tagsTarget.classList.contains(this.openClass)
  }

  get ellipsis (): boolean {
    return this.tagsTarget.scrollHeight <= this.tagsTarget.clientHeight
  }
}
